// extracted by mini-css-extract-plugin
export default {"like":"like_like__F9c41"};